<template>
  <section class="site-section newsletter" :class="theme">
    <div class="site-container">
      <div class="newsletter-item">
        <h4>Newsletter</h4>
        <p>Cadastre seu e-mail e receba informações sobre seus direitos</p>
        <div class="input">
          <input type="email" placeholder="Digite seu e-mail" ref="email" />
          <a class="control text-orange" v-on:click="submitEmail()">
            <div>ENVIAR <arrow-horizontal width="18" /></div>
          </a>
        </div>
      </div>
      <div class="newsletter-item">
        <h4>Siga-nos</h4>
        <p>Siga-nos através da rede social de sua preferência.</p>
        <social-networks icon-width="35" />
      </div>

      <modal :active.sync="modalContactIsOpen">
        <div class="text-center">
          <h3>Sua mensagem foi enviada com sucesso!</h3>
        </div>
      </modal>
    </div>
  </section>
</template>

<script>
import ArrowHorizontal from "@/components/Svg/ArrowHorizontal.vue";
import SocialNetworks from "./SocialNetworks";
import api from "../services/api";
import Modal from "@/components/Modal";

export default {
  components: { ArrowHorizontal, SocialNetworks, Modal },

  props: ["theme"],

  data() {
    return {
      modalContactIsOpen: false,
    };
  },

  computed: {
    socials_networks() {
      return [
        { icon: "facebook", title: "Facebook" },
        { icon: "linkedin", title: "Linkedin" },
        { icon: "youtube", title: "Youtube" },
      ];
    },
  },

  methods: {
    async submitEmail() {
      const email = this.$refs.email.value;
      if (email) {
        await api.post(`newsletter?email=${email}`);
        // console.log("ok", 'modal');
        this.$refs.email.value = '';
        this.modalContactIsOpen = true;
      }
    },
  },
};
</script>

<style>
</style>
